/**
 * Shared MUI `sx` for Today / All `ToggleButtonGroup` on dashboard cards
 * (Balance Receivable, Upcoming Service Renewables, etc.).
 */
export const dashboardTodayAllTabsSx = {
  border: "1px solid #d2d6da",
  borderRadius: "12px",
  p: "3px",
  bgcolor: "#f8f9fa",
  "& .MuiToggleButton-root": {
    border: "none",
    borderRadius: "9px !important",
    px: 1.5,
    py: 0.55,
    minWidth: 70,
    fontSize: "0.74rem",
    fontWeight: 700,
    letterSpacing: "0.03em",
    color: "#344767",
    textTransform: "uppercase",
    transition: "all 0.2s ease",
  },
  "& .MuiToggleButton-root.Mui-selected": {
    bgcolor: "#ffffff",
    color: "#111827",
    boxShadow: "0 2px 5px rgba(17, 24, 39, 0.12)",
  },
  "& .MuiToggleButton-root:hover": {
    bgcolor: "#eef2f7",
  },
  "& .MuiToggleButton-root.Mui-selected:hover": {
    bgcolor: "#ffffff",
  },
};
